// extracted by mini-css-extract-plugin
export default {"custom-amount-input":"DonationAmountForm-module__custom-amount-input--kEcan"};